import React, { useCallback, useEffect, useState } from 'react';

import styles from './notification.module.scss';
import { INotification } from './types';

export const Notification: React.FC<INotification> = ({
  title,
  message,
  isAutoClose = true,
  timeClose = 1500,
  onClose,
}) => {
  const [isHiding, setIsHiding] = useState(false);

  const handleClose = useCallback(() => {
    setIsHiding(true);
    setTimeout(() => {
      onClose();
    }, 600);
  }, [onClose]);

  useEffect(() => {
    if (isAutoClose) {
      setTimeout(handleClose, timeClose);
    }
  }, [isAutoClose, timeClose, handleClose]);

  return (
    <div
      className={`${styles.notificationRoot} ${isHiding ? styles.hiding : ''}`}
    >
      <div className={styles.notificationBody}>
        <div className={styles.notificationTitle}>{title}</div>
        {message}
        {!isAutoClose && (
          <button onClick={handleClose} className={styles.closeButton}>
            ×
          </button>
        )}
      </div>
    </div>
  );
};
